module.exports = __webpack_public_path__ + "static/media/how_to_reg_selected.b882eb5a.svg";